import React from 'react';
import { cn } from '../../lib/cn';

export interface TabItem {
  value: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
}

export interface TabsProps {
  tabs: TabItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({ tabs, value, onChange, className }) => (
  <div role="tablist" className={cn('inline-flex items-center gap-1 rounded-lg bg-surface-3 p-1', className)}>
    {tabs.map((tab) => {
      const active = tab.value === value;
      return (
        <button
          key={tab.value}
          role="tab"
          aria-selected={active}
          onClick={() => onChange(tab.value)}
          className={cn(
            'inline-flex items-center gap-2 rounded-md px-3.5 py-1.5 text-sm font-medium transition-colors duration-150',
            active
              ? 'bg-surface-1 text-foreground shadow-xs'
              : 'text-foreground-muted hover:text-foreground'
          )}
        >
          {tab.icon}
          {tab.label}
        </button>
      );
    })}
  </div>
);
